import React from 'react';
import { View, Text, ImageBackground, Image, ScrollView, Dimensions,TouchableHighlight,TouchableWithoutFeedback,TouchableOpacity} from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';
import style from './perfilMulti/style';
import Menu from '../menu';
import Modal from "modal-react-native-web";
import api from '../config/api_urls';
import XarxesSocials from '../PopUps/xarxesSocials';


export default class Perfil extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.route.params;
    this.state['premis'] = [];
    this.state['imatge'] = [];
    this.state['postes'] = [];
    this.state['joc'] = "";
    this.state['gameList']=[];
    this.state['visible']= false;
    this.state['SobreVisible'] = false;
    this.state['imgClick'] = 0;
    this.state['jaRenderitzat'] = false;
    this.state['currentGameView'] = 0;
    this.state['finished_games'] = null;
    if (typeof this.state.nom === 'undefined') {
      this.state['nom'] = '';
    }
    if (typeof this.state.cookies === 'undefined') {
      this.state['cookies'] = '';
    }
  }
  
  componentDidMount() {
    this.getGameList();
    this.getNom();
    // this.isCardRended();
    AsyncStorage.setItem('anarCredits',true);
    setTimeout(()=>{this.getGamePoints()},50)     
    AsyncStorage.getItem('finished_games').then((value) => {
      this.setState({finished_games:  value ? JSON.parse(value) : null})
    });
  }

  // isCardRended = async () => {
  //   try {
  //     const value = await AsyncStorage.getItem('jaRenderitzat');
  //     if (value !== null) {
  //       this.setState({ jaRenderitzat : value });
  //     } 
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

 getGamePoints = async () =>{
   let punts = 0;
   let length = 0;
   let postes = []
   let passedPois = []
   await AsyncStorage.getItem('Jocs360').then((value) => {
    if(value !== null){
      let jocs = JSON.parse(value);
      for(let i = 0; i < jocs.length;i++){
        punts += jocs[i].score;
      }
    }
  })
  
  for( let i = 0; i < this.state.gameList.length;i++){
    const value = await AsyncStorage.getItem('Game'+[this.state.gameList[i]]);
    if(value !== null){
      //console.log(JSON.parse(value).idioma);
      if(JSON.parse(value).idioma == this.state.idioma){
        punts += JSON.parse(value).score;
        postes += JSON.parse(value).gainedRewardsIds+",";
        passedPois += JSON.parse(value).passedPoisIds+",";
        let aux = passedPois.split(',')
        length = aux.length -1;
      }
    }
  }
 
  this.setState({joc:{score : punts , gainedRewardsIds : postes , passedPoisIds : passedPois , pois : length}})
 }

  getGameList = async () => {
    try {
      const value = await AsyncStorage.getItem('Gamelist');
      if (value !== null) {
        this.setState({ gameList: value.split(",") });
      } 
    } catch (e) {
      console.log(e);
    }
  }
  getNom = async () => {
    try {
      const value = await AsyncStorage.getItem('nom');
      if (value !== null) {
        this.setState({ nom: value });
      }
    } catch (e) {
      console.log(e);
    }
  }


  imatges(){
    return this.state.projecte.premis.map((data, i) => {   
      
      if(data.superPremi){
        if(i+1 == this.state.joc.pois){ //get last
          return(this.animacioCarta(data,i))
        }else{
          return(this.superPremi(data,i))
        }

      }else{
       return(this.renderitzarPremi(data,i))
      }
    })
  } 

animacioCarta(data,i){
  if(!this.state.jaRenderitzat){  
    setTimeout(()=>{ this.setSobreVisible(true); this.setState({imgClick : i});  this.setState({jaRenderitzat : true});},100)
     return(null)
    }else{
      return(this.superPremi(data,i))
    }
}

superPremi(data,i){
  return(
    <View style={{width:'100%', alignContent:'center'}}>
      <View style={{alignItems:'center'}}>
        <TouchableHighlight
          style={[style.button]}
          onPress={() => {
            this.setModalVisible(true);
            this.setState({imgClick : i})
          }}
        >
          { this.isInPassedPois(data['poi_id'+this.state.idioma]) ? 
          (

          <Image style={[style.superPremiImg, this.isInPassedPois(data['poi_id'+this.state.idioma]) ? null : style.difuminat  ]} source={{ uri: api.api_url + data.Premi.url }} />
          )
          :
          (
            <Image style={style.noAconseguit}source={require('../../img/premiUndefined.png')} />        
          )}
        </TouchableHighlight> 
        <Text style={{ alignSelf: 'center', color: "white", fontWeight: 500, fontSize: 10, paddingVertical:5,pdingRight:5}}></Text>          
      </View>
    </View>
  )
}

//Renderitzar Premi tant vertical com horitzontal
renderitzarPremi(data,i){
  //if(this.state.projecte.PremiVertical){
    return(
      <View style={[this.state.projecte.MarcPremis ? 
        {backgroundColor:this.state.projecte.ColorMarcPremis,paddingHorizontal:1,paddingTop:5,paddingBottom:15,borderRadius:10,marginHorizontal:5}
        : 
        {width:'33%', alignContent:'center'}]}>
        <View style={{alignItems:'center'}}>
          <TouchableHighlight
            style={[style.button]}
            onPress={() => {
             this.setModalVisible(true);
             this.setState({imgClick : i})
            }}
          >
            { this.isInPassedPois(data['poi_id'+this.state.idioma]) ? 
            (
            this.isInRewardsPoints(data['poi_id'+this.state.idioma]) ? 
              <Image style={style.aconseguit} source={{ uri: api.api_url + data.Premi.url }} />
              :
              <Image style={[style.noAconseguit,{opacity:0.3}]} source={{ uri: api.api_url + data.Premi.url }} />
            ):
            (
            <View style={{alignItems:'center'}}>        
              <Image style={style.noAconseguit}source={require('../../img/premiUndefined.png')} />        
            </View> 
            )
            }
          </TouchableHighlight>  
          <Text style={{ alignSelf: 'center', color: "white", fontWeight: 500, fontSize: 10, paddingVertical:5,pdingRight:5}}></Text> 
        </View>
      </View>
    )
}

isInRewardsPoints(id){
  if(this.state.joc.gainedRewardsIds != null && this.state.joc.gainedRewardsIds != undefined){
      if(this.state.joc.gainedRewardsIds.includes(id)){
        return true ;
      }else return false; 
    }
  return false;
}

isInPassedPois(id){
 if(this.state.joc.passedPoisIds != null){
  return(this.state.joc.passedPoisIds.includes(id))
 }else{
  return(false)
 }
  
}


/*********** 
  MODAL
 ***********/
setModalVisible = visible => {
  this.setState({ visible });
};

setSobreVisible = SobreVisible => {
  this.setState({SobreVisible})
}



renderItineraris(){

  let items = []
  this.state.projecte.pagines.map((itinerari, index) => {
    let isFinished = this.state.finished_games ? this.state.finished_games.find((game) => game.gameId == itinerari.id) : null;
    let color = isFinished ? '#d97e7d' : '#464958';

     if(itinerari.Tipus != "Tipus3"){
      items.push(
      <TouchableOpacity style={style.botoItinerari} key={index} onPress={()=>{this.state.currentGameView = itinerari ; this.state.navigation.navigate('imatgeItinerari', this.state); }}>
          <View style={[style.itinerariContainer,{backgroundColor : color}]}>
              <Text style={{fontSize: '1rem', fontWeight: 'bold', padding: 5, fontFamily:'Brushway' }}>
                  <Text style={[style.itinerariText]}>{itinerari['Nom'] ? itinerari['Nom'+this.state.idioma].toUpperCase() : null}</Text>
              </Text>
          </View>
      </TouchableOpacity>
      )
     }
  })
  return items
}

render() {  
  return (
    <View style={{ flex: 1, width:'100%',height:Dimensions.get('window').height}}>
          <ImageBackground source={this.state.projecte['FonsPantalla7'] ? { uri: api.api_url + this.state.projecte['FonsPantalla7'].url } : null} style={style.imageBackground}>
                {/* Box Perfil (NOM) */}
                <View style={{flex:15,justifyContent:'center',alignItems:'center'}}>
                    <View style={style.boxNom}>
                        <Text style={style.textPerfil}>{this.state.projecte['TitolPerfil'+this.state.idioma]}</Text>
                        <Text style={style.nom}>{this.state.nom}</Text>
                    </View>
                </View>
                {/* Box Perfil (PUNTS) */}
                <View style={{flex:10,display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: 'center'}}>
                    <View style={{width: "40%", height: "90%", justifyContent: "center"}}>
                        <View style={{alignSelf: 'center', backgroundColor: "#5cc0ed", alignItems: "center", justifyContent: "center", width: "90%", height: "100%"}}>
                            <Text style={style.SecondTitle}>{this.state.projecte['PuntsPerfil'+this.state.idioma]}</Text>
                            <Text style={style.SecondText}>{this.state.joc?.score}</Text>
                        </View>
                        
                    </View>
                    <View style={{width: "40%", height: "90%", justifyContent: "center"}}>
                        <View style={{alignSelf: 'center', width: "90%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: "#5cc0ed"}}>
                            <Text style={style.SecondTitle}>{this.state.recursos.find(e=> e.tipus_recurs == "itinerari")["text_recurs"+this.state.idioma]}</Text>
                            <Text style={style.SecondText}>{this.state.finished_games ? this.state.finished_games.length : 0}/{4}</Text>
                        </View>
                    </View>
                </View>

                {/* Itineraris */}
                <View style={{flex:20,alignItems:'center',justifyContent:'center',width:'100%',alignItems: "center", justifyContent: "center",flexDirection:'row'}}>
                    
                    <ScrollView style={style.caixa}>
                        <View style={{
                            justifyContent: 'center',
                            flexGrow: 0,
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap'
                        }}>
                            {this.renderItineraris()}
                        </View>
                    </ScrollView>
                </View>

                {/* Compartir xarxes */}
                <View style={{flex:15,justifyContent:'center',alignItems:'center', paddingBottom:'2rem'}}>
                    <View style={{flex:1,justifyContent:'center',alignItems:'center',flexDirection:'row'}}>
                        <TouchableOpacity 
                        onPress={() => {this.state.navigation.navigate('Credits', this.state)}}
                        style={{height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.11, width: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.11}} >     
                          <Image style={{width:'100%',height: "90%",alignSelf:'center',resizeMode:'contain'}} source={{uri: api.api_url + this.state.recursos.find(e=> e.tipus_recurs == "perfil_info")["imatge_recurs"].url}} />    
                        </TouchableOpacity>
                        {XarxesSocials(this.state,{textSocial : encodeURI(this.state.projecte['textSocial'+this.state.idioma]).replaceAll('#', '%23')})}
                    </View>
                </View>
                {/* Menu */}
                <View style={{ flex: 2, bottom:0,left:0,right:0, position:'fixed', }}>
                  <Menu projecte={this.state}></Menu>
                </View>
            </ImageBackground>
    </View>
)
}
}
